define(function(require) {
	// general
	const CN = require('civicsUtils/constants');
	const InstrumentUtils = require('civicsUtils/instrument_utilities');
	const Marionette = require('backbone.marionette');
	const Utils = require('civicsUtils/general_utilities');
	const ViewManager = require('civicsUtils/view_manager');
	// models
	const CdrLogModel = require('civicsModels/cdr_log_model');
	const RequestInspectionModel = require('civicsModels/request_inspection_model');

	const TimePreferencesCollection = require('civicsCollections/code_definition_collection');
		// templates
	const tpl = require('civicsViews/inspection_request/templates/t_itv_inspection_cancel_assignment.hbs');
	const AvailableFeatures = require('civicsUtils/available_features');

	return Marionette.ItemView.extend({
		initialize: function(options) {
			this.config = options.config;
			this.model = options.model;
			this.modalRegion = options.modalRegion;
			this.getTimePreferencesCollection();
		},
		onShow: function() {

		},
		onRender:function(){
			this.$el.rhythmThemeInit();
		},
		onDomRefresh: function(){
			this.ui.message.maxlength();
		},
		template: tpl,
		className: 'inspection-detail-modal',
		events: {
			'click @ui.btnClose': 'backClicked',
			'click @ui.btnBack': 'backClicked',
			'click @ui.btnCancelAssignment': 'cancelAssignmentClicked',
		},
		ui:{
			btnClose: '.bbm-btn-close',
			btnBack: '.btn-back-confirmation',
			btnCancelAssignment: '.btn-cancel-confirmation',
			message: '#message'
		},
		backClicked:function(){
		if(__DEV__) console.log('itv cancel assignment -- backClicked');

			this.triggerMethod('back:clicked');

			if(this.modalRegion) {
				this.modalRegion.hideModal();
			}
			else {
				this.destroy();
			}
		},
		enableButtons: function(enable){
			this.ui.btnBack.prop('disabled', !enable);
			this.ui.btnCancelAssignment.prop('disabled', !enable);
		},
		getTimePreferencesCollection:function(){
			var self = this;
			if (typeof this.timePreferencesCollection == 'undefined') {
				this.timePreferencesCollection = new TimePreferencesCollection();
				this.timePreferencesCollection.moniker = 'Hansen.CDR.' + this.config.instrumentType + '.TimePreference';
				this.timePreferencesCollection.fetch()
					.done(function() {
						if(__DEV__) console.log('itv_my_inspection_assignments -- done getting collection');
						self.render();
					})
					.fail(function() {
						if(__DEV__) console.log('itv_my_inspection_assignments -- failed to get collection');
					})
			} else {
				this.render();
			}
		},
		cancelAssignmentClicked: function cancelAssignmentClicked() {
			if (__DEV__) console.log('itv cancel assignment -- logOperation, operationType: ', this.config.operationType);
			var self = this;
			var data = ViewManager.fromWindow(this);
			var log = new CdrLogModel();
			var now = new Date($.now());
			var dataType = this.config.instrumentType;
			var saveData = {};
			saveData.application = this.model.get('application.id');
			saveData.inspection = this.model.get('id');
			saveData.logType = ViewManager.globalConfig().get(dataType + '.' + this.config.operationType + 'InspectionLogType');
			saveData.StartDateTime = now.yyyymmdd();
			saveData.comments = data.message;
			log._dataType = dataType;
			log.save(saveData)
			.done(function (response, status, xhrResponse) {
				if (__DEV__) console.log('itv cancel inspection assignment -- save Log done before save inspection model');
	  		if(AvailableFeatures.SpecialInstructions()){
					var inspectionId = self.model.get('id');
					self.model = new RequestInspectionModel();
					self.model.formatUrlRoot(self.config.instrumentType);
					self.model.set({
							id: inspectionId
						});
					self.model.destroy({
						success: function() {
							if (self.modalRegion) {
								self.modalRegion.hideModal();
							} else {
								self.destroy();
							}
							self.triggerMethod('cancelInspectionAssignmentConfirmation:clicked');
					}.bind(this)
					});
				} else {
				self.model.formatUrlRoot(self.config.instrumentType);
				self.model.set({
					'assignedToProvider': { id: 1 },
					'callDateTime': CN.DATE_TIME_MIN_VAL,
					'scheduledDateTime': CN.DATE_TIME_MIN_VAL,
					'timePreference': ''
				});
				self.model.save(null, {
					error: function error(model, response, options) {
						ViewManager.errorToWindow(response, this);
					}
				}).done(function (response, status, xhrResponse) {
					if (__DEV__) console.log('itv cancel inspection assignment -- cancelAssignment done function after save inspection model');
					if (self.modalRegion) {
						self.modalRegion.hideModal();
					} else {
						self.destroy();
					}

					self.triggerMethod('cancelInspectionAssignmentConfirmation:clicked');
				}).fail(function (response, status, xhrResponse) {
					ViewManager.errorToWindow(response);
					self.enableButtons(true);
				});
			}
			}).fail(function (response, status, xhrResponse) {
				if (response.responseJSON.responseStatus.message.indexOf('You do not have access to add a log to this instrument') != -1) {
					ViewManager.openAlert(i18n.t('CIVICS.INSPECTION_REQUEST.DO_NOT_HAVE_ACCESS_ERROR'));
				} else {
					ViewManager.errorToWindow(response, this);
				}
				self.enableButtons(true);
			});
		},
		templateHelpers: function(){
			var self = this;
			return {
				modelId: this.model.get('id'),
				isCancel: this.config.operationType == 'cancel',
				title: (this.config.operationType == 'cancel' ?  i18n.t('CIVICS.INSPECTION_REQUEST.CANCEL_INSPECTION') : i18n.t('CIVICS.INSPECTION_REQUEST.DECLINE_INSPECTION')),
				btnLabel: (this.config.operationType == 'cancel' ?  i18n.t('CIVICS.INSPECTION_REQUEST.CANCEL_REQUEST') : i18n.t('CIVICS.INSPECTION_REQUEST.DECLINE_REQUEST')),
				hasSite: self.config.instrumentType != 'tradeLicense',
				timePreferenceDescription: function() {
					var desc = '';
					_.forEach(self.timePreferencesCollection.models, timePref=>{
						if( timePref.attributes.code == self.model.get('timePreference') ){
							desc = timePref.attributes.description;
						}
					})
					return desc;
				}
			};
		}
	});
});
